import api from 'services/api.service';

const resource = '/users';

export const shortUrl = ({ url }) => api
  .post(`${resource}/short-url`, { url });

export const invite = ({ id, shouldSendEmail, shouldSendSms }) => api
  .post(`${resource}/invite`, { id, shouldSendEmail, shouldSendSms });

export const generateOnboardingPdf = (data) => api
  .post(`${resource}/onboarding-pdf`, data);

export const sendWelcomeClientEmail = () => api
  .post(`${resource}/welcome-client-email`);

export const sendNewClientEmail = (body) => api
  .post(`${resource}/new-client-email`, body);

export const sendNewTeamMemberEmail = () => api
  .post(`${resource}/new-team-member-email`);

export const sendNewLeadEmail = (data) => api
  .post(`${resource}/new-lead-email`, data);

export const sendPublicDocumentsEmail = (data) => api
  .post(`${resource}/public-documents-email`, data);

// TODO: get deal on api side
export const sendDealUnderContractEmail = ({ clientEmail, deal }) => api
  .post(`${resource}/deal-under-contract-email`, { clientEmail, deal });

export const sendDealCreatedForAgent = ({ dealId }) => api
  .post(`${resource}/deal-created-for-agent`, { dealId });

// TODO: get deal on api side
export const sendClientTransactionClosedEmail = (deal) => api
  .post(`${resource}/transaction-closed-email`, { deal });

export const sendVerificationEmail = () => api
  .post(`${resource}/verification-email`);

export const getNeedProcessingClients = () => api
  .get(`${resource}/need-processing-clients`);

export const addClientLead = (data) => api
  .post(`${resource}/add-client-lead`, data);

export const removeLead = (data) => api
  .delete(`${resource}/remove-lead`, data);

export const acceptLeads = (data) => api
  .post(`${resource}/accept-leads`, data);

export const getRealtors = () => api
  .get(`${resource}/realtors`);

export const addToContacts = () => api
  .post(`${resource}/add-to-contacts`);

export const getPublicProfile = (userId) => api
  .get(`${resource}/${userId}/public-profile`);

export const getRealtorsByTeam = ({ teamId }) => api
  .get(`${resource}/realtors-by-team`, { teamId });

export const getClientsByTeam = ({ teamId }) => api
  .get(`${resource}/clients-by-team`, { teamId });

export const updateMilestonesSorting = ({ milestonesSorting }) => api
  .post(`${resource}/update-milestones-sorting`, { milestonesSorting });

export const updateRealtorsTeam = (data) => api
  .post(`${resource}/update-realtors-team`, data);

export const deleteAgent = ({ agentId }) => api
  .delete(`${resource}/${agentId}`);

// Auth
export const updateAuthUserEmail = (data) => api
  .post(`/auth/update-auth-user-email`, data);
